import React from 'react';
import './app-header.scss';
import DDLogo from '@svg/dd-logo.svg?react';
import AppNavigation from '../app-navigation/app-navigation';
import { CustomerServicesDropdown } from '../customer-service-dropdown/customer-service-dropdown';
import { UserLogin } from '../../user/user-login';
import NotificationButton from '../notification/notification-button';
import HelpItem from '../help-item/help-item';
import { appLogoWrapperClassName } from 'src/utils/constants';

interface AppHeaderProps {
    isECM?: boolean;
    isBronze?: boolean;
}

const AppHeader: React.FC<AppHeaderProps> = ({ isECM, isBronze }) => {
    return (
        <div className="app-header">
            <div className={appLogoWrapperClassName}>
                <DDLogo className="app-logo" id="logo" />
            </div>
            {!isBronze && !isECM && (
                <div className="app-navigation-wrapper">
                    <AppNavigation />
                </div>
            )}
            <div className={'app-header-right'}>
                { !isECM && <CustomerServicesDropdown />}
                { !isBronze && <NotificationButton fetchAllServices={isECM}/> }
                <HelpItem />
                <UserLogin />
            </div>
        </div>
    );
};

export default AppHeader;
